import { z } from 'zod';
import { emailValidation, nameValidation } from '../../../validation';

export const ReferralAvivaCaseManagerSchema = z.object({
  email: emailValidation('Case manager email is required'),
  firstname: nameValidation('Case manager first name is required'),
  lastname: nameValidation('Case manager last name is required'),
});

export type ReferralAvivaCaseManager = z.infer<
  typeof ReferralAvivaCaseManagerSchema
>;
